import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0m2 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-2 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Menu-Vertical-Outlined_svg__a",
      width: 8,
      height: 32,
      x: 20,
      y: 8,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0m2 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-2 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Menu-Vertical-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgMenuVerticalOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MenuVerticalOutlined_default = SvgMenuVerticalOutlined;

export { MenuVerticalOutlined_default as default };
